module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "fuente box-title p-t-10"
  }, [_vm._v(_vm._s(_vm.nombreAppFil) + ": " + _vm._s(_vm.descripcionRol))]), _vm._v(" "), _c('h3', {
    staticClass: "fuente box-title p-t-2"
  }, [_vm._v("(APLICACIÓN: ROL)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "fuente col-xs-12 table-responsive"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "fuente fs-12 table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tablaDetalle_info",
      "role": "grid",
      "id": "tablaDetalle"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.trabsOrder), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1 table-center-header"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nombres) + " " + _vm._s(item.apePaterno) + " " + _vm._s(item.apeMaterno) + "\n                                                ")]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [(_vm.ususByRol.length > 0 && _vm.ususByRol.some(function (us) { return us.idUsuario === item.idUsuario; })) ? _c('span', [_vm._v("\n                                                        SI ")]) : _c('span', [_vm._v(" NO ")])]), _vm._v(" "), _c('td', {
      staticClass: "table-center-header"
    }, [(_vm.ususByRol.length > 0 && _vm.ususByRol.some(function (us) { return us.idUsuario === item.idUsuario; })) ? _c('span', {
      staticClass: "badge bg-red",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAnular"
      },
      on: {
        "click": function($event) {
          return _vm.verAnular(item)
        }
      }
    }, [_vm._v("X\n                                                    ")]) : _c('span', {
      staticClass: "badge bg-blue",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modalAgregar"
      },
      on: {
        "click": function($event) {
          return _vm.ver(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "fuente col-md-12",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.error.desError) + "\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAnular",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                                            Se anulará de este rol a: " + _vm._s(_vm.trab.nombres) + " " + _vm._s(_vm.trab.apePaterno) + " " + _vm._s(_vm.trab.apeMaterno) + "\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-danger fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("Anular")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalAgregar",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.texto))])]), _vm._v(" "), _c('div', {
    staticClass: "fuente modal-body"
  }, [_vm._v("\n                                            Se agregará a este rol a: " + _vm._s(_vm.trab.nombres) + " " + _vm._s(_vm.trab.apePaterno) + " " + _vm._s(_vm.trab.apeMaterno) + "\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "fuente btn btn-primary fs-13",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.merge()
      }
    }
  }, [_vm._v("\n                                                Agregar")])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc table-center-header",
    attrs: {
      "aria-label": "ITEM",
      "aria-sort": "ascending",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ITEM")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    attrs: {
      "aria-label": "URL",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("TRABAJADOR")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ESTADO",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("ESTADO\n                                                ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting table-center-header",
    attrs: {
      "aria-label": "ANULAR / AGREGAR",
      "aria-controls": "tablaDetalle",
      "tabindex": "0"
    }
  }, [_vm._v("\n                                                    ANULAR  "), _c('span', {
    staticClass: "badge bg-red"
  }, [_vm._v("X")]), _vm._v(" / AGREGAR "), _c('span', {
    staticClass: "badge bg-blue"
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('h4', {
    staticClass: "fuente modal-title m-t-10",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("¿DESEA ANULAR EL\n                                                TRABAJADOR DE ESTE ROL?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("X")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-140c8df3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Rol_Detalle.vue
// module id = 328
// module chunks = 1